import { useDispatch, useSelector } from "react-redux";

import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { TableActionProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { selectIsTableRowExpanded, selectActiveLeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import trackingService from "app/pages/sales-intelligence/modules/lists/services/tracking/trackingService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import RemoveFromListButtonTracked from "app/pages/sales-intelligence/sub-modules/opportunities/containers/RemoveFromListButton/RemoveFromListButtonTracked";
import { toggleRightBar } from "app/pages/workspace/sales/sub-modules/common/store/action-creators";
import { openHooksModalV5 } from "app/services/ModalService";

import RemoveFromListPanelContainer from "../RemoveFromListPanel/RemoveFromListPanelContainer";

import { TOOLTIP_TRANSLATABLE } from "./const";

const RemoveFromListButtonContainer = (props: TableActionProps) => {
    const dispatch = useDispatch();
    const { translate } = useTranslate();

    const canDeleteOpportunities = salesSettingsHelper.canDeleteOpportunities();

    const isTableRowExpanded = useSelector(selectIsTableRowExpanded);
    const activeLeadsType = useSelector(selectActiveLeadsType);

    const handleClick = (): void => {
        dispatch(toggleRightBar(false));
        props.onActivate(() => RemoveFromListPanelContainer);
    };

    if (!canDeleteOpportunities) {
        return (
            <IconButton
                type="flatTrial"
                iconName="sparkles"
                onClick={() => {
                    trackingService.trackRemoveHookClick();
                    openHooksModalV5("SalesSolutionLists");
                }}
            >
                {translate("si.multi_selector.initial_state.button.remove.label")}
            </IconButton>
        );
    }

    return (
        <RemoveFromListButtonTracked
            tooltipContent={<I18n translatable={TOOLTIP_TRANSLATABLE[activeLeadsType]} />}
            isDisabled={props.isDisabled || isTableRowExpanded}
            onClick={handleClick}
        />
    );
};

export default RemoveFromListButtonContainer;
